import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';

export type FilterData = {
  filterOption: string;
  filterInfo: string;
};

export type customFilterTagProps = React.PropsWithChildren<{
  filter: FilterData;
  onClearFilter?: () => void;
}>;

const FilterTag = ({ filter, onClearFilter }: customFilterTagProps) => {
  return (
    <Container
      className={'px-3 py-2 custom-filter-tag d-flex align-items-center'}
    >
      <span
        className={'fw-light text-caption text-blue'}
      >{`${filter.filterOption}: ${filter.filterInfo}`}</span>
      <FontAwesomeIcon
        onClick={onClearFilter}
        className={'ms-7 text-blue quit-button'}
        icon={light('x')}
      />
    </Container>
  );
};

export default FilterTag;
